import {
  cfsReportSections,
  cfsTopSectionFields,
} from '@/pages/CFS/reports/cfsReport/template';
import type { CFSReportContext } from '@/pages/CFS/reports/cfsReport/types';

import type { CFSRedactionsMap } from '../data';
import CFSPrintCard from './CFSPrintCard';
import CFSSectionRenderer from './CFSSectionRenderer';

interface RedactionsPageProps {
  ctx: CFSReportContext;
  redactions: CFSRedactionsMap;
  toggleFieldRedaction: (
    sectionKey: string,
    itemIndex: number,
    fieldKey: string,
  ) => void;
  activeSearchTerm: string;
  currentMatchKey: string | null;
}

const RedactionsPage = ({
  ctx,
  redactions,
  toggleFieldRedaction,
  activeSearchTerm,
  currentMatchKey,
}: RedactionsPageProps) => {
  const allSections = [cfsTopSectionFields, ...cfsReportSections];

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col p-3 overflow-y-auto">
        {allSections.map((section) => (
          <CFSPrintCard key={section.key} title={section.title || undefined}>
            <CFSSectionRenderer
              section={section}
              ctx={ctx}
              sectionRedactions={redactions[section.key] ?? {}}
              onToggleField={(itemIndex, fieldKey) =>
                toggleFieldRedaction(section.key, itemIndex, fieldKey)
              }
              activeSearchTerm={activeSearchTerm}
              currentMatchKey={currentMatchKey}
            />
          </CFSPrintCard>
        ))}
      </div>
    </div>
  );
};

export default RedactionsPage;
